<!-- 开发设置 --  数据迁移 -- 数据迁移设置 -- 数据迁移列映射 -->
<template>
  <div>
    <Table
      ref="table"
      :loadObj='{}'
      :option="{
        importBtn: true,
      }"
      :colObj='{
        opId:3534,
        name:"数据迁移列映射",
        parentId:"SETUP_ID",
        parentName:"外部数据实体管理",
        parentPath:"/system/trans/outerSetup",
        parentQuery:{
        },
        addForm:{
        },
        dataClass:2,
        col:[]
      }'
    >
    </Table>
  </div>
</template>

<script>
import Table from '@/components/table/dataTablecSon';
export default {
  components: {
    Table
  },
  data() {
    return {
      firstEnter:true,
    };
  },
  computed: {
  },
  methods: {
  },
  created(){
  },
  activated(){
    if(this.firstEnter){
      this.firstEnter=false;
    }else{
      this.$refs.table.$refs.child.onLoad();
    }
  }
};
</script>

<style></style>